var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canView)?_c('q-btn',_vm._b({attrs:{"color":"primary","icon":"fa fa-plus","label":_vm.label},on:{"click":_vm.open}},'q-btn',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }